
import { Vue, Component } from 'vue-property-decorator';
import { AuthService } from './services';
import ApiConfig from './services/ApiConfig';
import { RouteNames } from './router/routes';
import { RawLocation } from 'vue-router';
import EnvironmentBanner from './components/EnvironmentBanner.vue';

@Component({
  components: { EnvironmentBanner },
})
export default class App extends Vue {
  private readonly authService: AuthService = new AuthService();

  created(): void {
    ApiConfig.AddUnauthorizedHandler(() => {
      this.authService
        .Logout()
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.$route.name !== RouteNames.Login) {
            const route: RawLocation = { path: '/login' };

            if (this.$route.fullPath !== '/') {
              route.query = { redirect: this.$route.fullPath };
            }

            void this.$router.push(route);
          }

          if (this.$q.loading.isActive) {
            this.$nextTick(() => {
              this.$q.loading.hide();
            });
          }
        });
    });
  }
}
